import cn from '../../utils/cn';
import { getExtension } from '../../utils/fileTypes';

/** Map an extension to the v2 badge class and its short label. */
export function badgeFor(name = '') {
  const ext = getExtension(name);
  if (ext === 'pdf') return { cls: 'ftype-pdf', label: 'PDF' };
  if (['doc', 'docx', 'rtf', 'txt', 'md'].includes(ext)) return { cls: 'ftype-doc', label: 'DOC' };
  if (['xls', 'xlsx', 'csv'].includes(ext)) return { cls: 'ftype-xls', label: 'XLS' };
  if (['ppt', 'pptx'].includes(ext)) return { cls: 'ftype-ppt', label: 'PPT' };
  if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext)) return { cls: 'ftype-img', label: 'IMG' };
  if (['zip', 'rar', '7z'].includes(ext)) return { cls: '', label: 'ZIP' };
  return { cls: '', label: (ext || 'FILE').slice(0, 4).toUpperCase() };
}

/** Folder glyph: light-accent fill, accent stroke (v2). */
export function FolderGlyph({ size = 28 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="var(--ac-l)"
      stroke="var(--ac)"
      strokeWidth="1.5"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </svg>
  );
}

/**
 * File-type badge: a tinted square with a text label ("PDF", "DOC"…) — no image assets.
 * Sizes: sm 24 · default 30 · lg 36 · xl 48.
 */
export default function FileTypeIcon({ name, type = 'document', size = 'md', className }) {
  if (type === 'folder') {
    const px = size === 'xl' ? 40 : size === 'lg' ? 28 : size === 'sm' ? 18 : 22;
    return (
      <span className={cn('row', className)} style={{ flex: 'none' }}>
        <FolderGlyph size={px} />
      </span>
    );
  }
  const { cls, label } = badgeFor(name);
  return (
    <span className={cn('ftype', cls, size !== 'md' && size, className)} aria-hidden="true">
      {label}
    </span>
  );
}
